import PageCard from 'features/shared/components/card/PageCard';
import React from 'react';
import ContractEnergyDTO from 'features/contracts/dtos/ContractEnergyDTO';
import InfoItem from 'features/shared/components/infoItem/InfoItem';
import AddressFormatter from 'features/shared/components/formatters/AddressFormatter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RolesChecker from 'features/customer/components/RolesChecker';
import RenderWrapper from 'features/shared/components/renderWrapper/RenderWrapper';
import { ContractType } from 'features/contracts/enums/contractType';
import { useTranslation } from 'react-i18next';

interface Props {
  contractEnergy: ContractEnergyDTO;
  contractType?: ContractType;
  setPlaceOfDeliveryDialogShow?: React.Dispatch<React.SetStateAction<boolean>>;
}

const SupplyPointCard = ({ contractEnergy, contractType, setPlaceOfDeliveryDialogShow }: Props) => {
  // translations
  const tLabels = useTranslation("contracts\\contracts").t;
  const tPlaceOfDeliveryType = useTranslation("contracts\\enums\\placeOfDeliveryType").t;

  //helpers
  const isProductionPlaceOfDelivery = () => {
    return contractEnergy.placeOfDeliveryType === "Production";
  };

  const getTitle = () => {
    if (isProductionPlaceOfDelivery()) {
      return tLabels("supplyPointCard.productionTitleCard");
    }

    return tLabels("supplyPointCard.titleCard");
  };

  // sub-renders
  const renderFormattedAddress = () => {
    return <AddressFormatter address={contractEnergy.placeOfDeliveryAddress!} />
  }
  
  const renderCustomerName = () => {
    if (!contractEnergy.namedByCustomer && setPlaceOfDeliveryDialogShow) {
      return (
        <RolesChecker enabledRoles="Contributor" unauthorizedRender={noPlaceOfDeliverName}>
          <button className="btn btn-sm btn-secondary mt-2" onClick={() => setPlaceOfDeliveryDialogShow(true)}>
            <FontAwesomeIcon icon="edit" />
            <span className="ml-1">{tLabels("supplyPointCard.setCustomName")}</span>
          </button>
        </RolesChecker>
      );
    } else if (setPlaceOfDeliveryDialogShow) {
      return (
        <div className="d-flex">
          <span className="font-weight-bold">{contractEnergy.namedByCustomer}</span>
          <RolesChecker enabledRoles="Contributor">
            <span className="text-secondary ml-1" role="button" onClick={() => setPlaceOfDeliveryDialogShow(true)}>
              <FontAwesomeIcon icon="edit" />
            </span>
          </RolesChecker>
        </div>
        )
    } else {
      return noPlaceOfDeliverName();
    }
  }

  const noPlaceOfDeliverName = () => <strong>-</strong>;

  // render
  return (
    <PageCard title={getTitle()}>
      <div className="row no-gutters">
        <div className="col-sm-12 col-lg-4 pb-2">
          <div className="row no-gutters">
            <div className="col-sm col-lg-12 pb-2 pb-sm-0 px-sm-3">
              <InfoItem title={tLabels("supplyPointCard.placeOfDelivery")} value={contractEnergy.placeOfDelivery} />
            </div>
            <RenderWrapper isVisible={() => !(contractType === "HeatSmallConsumption")}>
              <div className="col-sm col-lg-12 px-sm-3 pt-lg-2">
              <InfoItem title={tLabels("supplyPointCard.distributionCompany")} value={contractEnergy.distributionCompany} />
              </div>
            </RenderWrapper>
          </div>
        </div>
        <div className="col-sm-12 col-lg-4 px--sm-3 pb-2">
          <div className="row no-gutters">
            <div className="col-sm col-lg-12 pb-2 pb-sm-0 px-sm-3">
              <InfoItem title={tLabels("supplyPointCard.placeOfDeliveryType")} value={tPlaceOfDeliveryType(contractEnergy.placeOfDeliveryType!)} />
            </div>
            <div className="col-sm col-lg-12 px-sm-3 pt-lg-2">
              <InfoItem title={tLabels("supplyPointCard.customNamePlaceOfDelivery")} value={renderCustomerName()} valueBold={false} />
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-lg-4 px-sm-3 pb-2">
          <InfoItem title={tLabels("supplyPointCard.address")} value={renderFormattedAddress()} />
        </div>
      </div>
    </PageCard>
  )
}

export default SupplyPointCard;
